import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  @Input() public required = false;
  @Input() public placeholder = "";
  @Input() public tooltip = "";
  @Input() public name!: string;
  @Input() public noData?: string;
  @Output() public valChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() public type!: "text" | "phone" | "mail" | "number" | "decimal" | "password" | "date" | "dateTime" | "iban" | "textarea"
  private _val: any;

  constructor() { }

  get val(): any {
    switch (this.type) {
      case "number":
      case "decimal":
        if(typeof this._val === "string") {
          return parseFloat(this._val);
        }
        return this._val;
      default:
        return this._val;
    }
  }

  @Input()
  set val(v: any) {
    this._val = v;
  }

  ngOnInit(): void {
  }

  getType(): string {
    switch (this.type) {
      case "text":
      case "mail":
        return "text";
      case "number":
      case "decimal":
        return "number";
      case "phone":
        return "tel";
      case "password":
        return "password";
    }
  }

  getInputMode(): string {
    switch (this.type) {
      case "text":
        return "text";
      case "mail":
        return "email";
      case "number":
        return "numeric";
      case "decimal":
        return "decimal"
      case "phone":
        return "tel";
      case "password":
        return "";
    }
  }
}
